"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var __1 = require("../../../");
var context_1 = require("../../../../context");
var utils_1 = require("../../../../utils");
var Card_1 = require("../../../Card");
var Tabs_1 = require("../../../Tabs/Tabs");
exports.errorKeys = [
    'advice_quality',
    'managing_energy',
    'able_to_stay_warm',
    'most_useful_learned',
    'can_be_done_better',
];
var optsToTen = {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '10': '10',
};
var optsFeelings = {
    lot_less: 'A lot less',
    little_less: 'A little less',
    same: 'About the same',
    little_more: 'A little more',
    lot_more: 'A lot more',
};
var FeedbackForm = function (_a) {
    var tabId = _a.tabId;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var trans = context_1.useSemantics().trans;
    var setTabError = Tabs_1.useTabsContext().setTabError;
    var errors = formik_1.useFormikContext().errors;
    var _p = react_1.useState(((_b = errors.project) === null || _b === void 0 ? void 0 : _b.feedback) || {}), formErrors = _p[0], setFormErrors = _p[1];
    react_1.useEffect(function () { return setTabError(tabId, utils_1.objectHasAnyKey(formErrors, exports.errorKeys)); }, [formErrors]);
    react_1.useEffect(function () { var _a; return setFormErrors(((_a = errors.project) === null || _a === void 0 ? void 0 : _a.feedback) || {}); }, [(_c = errors.project) === null || _c === void 0 ? void 0 : _c.feedback]);
    return (react_1.default.createElement(Card_1.Card, { heading: trans('project:slhh::headings.feedback'), subHeading: trans('project:slhh::headings.project') },
        react_1.default.createElement(__1.FormControl, { errors: (_e = (_d = errors.project) === null || _d === void 0 ? void 0 : _d.feedback) === null || _e === void 0 ? void 0 : _e.advice_quality, label: trans('project:slhh::labels.advice-quality'), help: trans('project:slhh::help.1-10-scale-reasoning') },
            react_1.default.createElement(__1.Select, { width: "xs", options: optsToTen, name: "project.feedback.advice_quality" })),
        react_1.default.createElement(__1.FormControl, { errors: (_g = (_f = errors.project) === null || _f === void 0 ? void 0 : _f.feedback) === null || _g === void 0 ? void 0 : _g.managing_energy, label: trans('project:slhh::labels.managing-energy') },
            react_1.default.createElement(__1.Select, { width: "xs", options: optsFeelings, name: "project.feedback.managing_energy" })),
        react_1.default.createElement(__1.FormControl, { errors: (_j = (_h = errors.project) === null || _h === void 0 ? void 0 : _h.feedback) === null || _j === void 0 ? void 0 : _j.able_to_stay_warm, label: trans('project:slhh::labels.able-to-stay-warm') },
            react_1.default.createElement(__1.Select, { width: "xs", options: optsFeelings, name: "project.feedback.able_to_stay_warm" })),
        react_1.default.createElement(__1.FormControl, { errors: (_l = (_k = errors.project) === null || _k === void 0 ? void 0 : _k.feedback) === null || _l === void 0 ? void 0 : _l.most_useful_learned, label: trans('project:slhh::labels.most-useful-learned') },
            react_1.default.createElement(__1.Input, { fast: true, name: "project.feedback.most_useful_learned", maxLength: 200 })),
        react_1.default.createElement(__1.FormControl, { flush: true, errors: (_o = (_m = errors.project) === null || _m === void 0 ? void 0 : _m.feedback) === null || _o === void 0 ? void 0 : _o.can_be_done_better, label: trans('project:slhh::labels.can-be-done-better') },
            react_1.default.createElement(__1.Input, { fast: true, name: "project.feedback.can_be_done_better", maxLength: 200 }))));
};
exports.default = FeedbackForm;
//# sourceMappingURL=FeedbackForm.js.map